<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100 sdcCardItem">
        <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
            <div class="row pt-3">
                <div class="col-lg-2 col-md-12 col-xs-12 col-sm-6">
                    <button mat-flat-button color="primary" matTooltip="Leitor Cerar" (click)="openDialog('Cerar')"
                        class="sdcBtnSize" [disabled]="disableBtn">
                        <i class="{{iconBarCodeField}}"></i> Leitor Cerar
                    </button>
                    <button mat-flat-button color="warn" (click)="delete()" class="sdcBtnSize" *ngIf="btnExcluir"
                        matTooltip="Excluir">
                        <i class="fa fa-minus fa-1x btnIcon"></i> Excluir
                    </button>
                </div>
                <div class="col-lg-3 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Cerar</mat-label>
                        <input matInput id="txtCerar" #txtCerar maxlength="17" formControlName="cd_cerar"
                            (blur)="getQua007Data()" (blur)="getRs009Data()" (blur)="makeCalcSdc()"
                            [class.InputBlockColor]="readonlyCerar" [readonly]="readonlyCerar">
                        <i matSuffix class="{{iconBarCodeField}}" *ngIf="!readonlyCerar"></i>
                        <i matSuffix class="{{iconDisableField}}" *ngIf="readonlyCerar"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                        <mat-hint align="end">{{txtCerar.value.length}} / 17</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.cd_cerar)}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-3 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Contrato</mat-label>
                        <input matInput id="txtContrato" #txtContrato maxlength="16" formControlName="cd_contrato"
                            readonly class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                        <mat-hint align="end">{{txtContrato.value.length}} / 16</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.cd_contrato)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Peso RW (kg)</mat-label>
                        <input matInput id="txtPesoRw" #txtPesoRw maxlength="10" formControlName="qt_rw_kg" readonly
                            class="InputBlockColor" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                        <mat-hint align="end">{{txtPesoRw.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.qt_rw_kg)}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row pt-3 mb-3">
                <div class="col-lg-2 col-md-6 col-xs-12 col-sm-6 offset-2">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Lote de Rw - Exemplo: AB1234567 </mat-label>
                        <input matInput id="txtLoteRw" #txtLoteRw readonly maxlength="9" formControlName="cd_lote_rw"
                            class="InputBlockColor">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                        <mat-hint align="end">{{txtLoteRw.value.length}} / 9</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.cd_lote_rw)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">% Umidade CERAR</mat-label>
                        <input matInput id="txtUmidCerar" #txtUmidCerar maxlength="10"
                            formControlName="qt_umidade_cerar" readonly class="InputBlockColor" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                        <mat-hint align="end">{{txtUmidCerar.value.length}} / 10</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.qt_umidade_cerar)}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">% Descarregado</mat-label>
                        <input matInput id="txtDescarregado" #txtDescarregado maxlength="5"
                            formControlName="qt_porcentagem_descarregado" (blur)="makeCalcSdc()"
                            class="InputUnblockColor" currencyMask
                            [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                        <i matSuffix class="{{iconEnableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                        <mat-hint align="end">{{txtDescarregado.value.length}} / 5</mat-hint>
                        <mat-error>{{hasErrorFormControl(formulario.controls.qt_porcentagem_descarregado)}}
                        </mat-error>
                        <mat-error *ngIf="formulario.controls['qt_porcentagem_descarregado'].hasError('max')">
                            O valor máximo permitido Descarregado é 100%.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-2 col-md-6 col-xs-12 col-sm-6">
                    <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                        floatLabel="{{formFieldFloatLabel}}">
                        <mat-label class="InputLabelColor">Temperatura Máxima Transporte (ºC)</mat-label>
                        <input matInput readonly id="txtTempMaxTrans" #txtTempMaxTrans
                            formControlName="qt_temperatura_maxima_do_tempo_total_de_transporte" class="InputBlockColor"
                            currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }">
                        <i matSuffix class="{{iconDisableField}}"></i>
                        <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                        <mat-error>
                            {{hasErrorFormControl(formulario.controls.qt_temperatura_maxima_do_tempo_total_de_transporte)}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </div>
</div>